import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";

import PageWrapper from "../../../../components/layout/page/PageWrapper";
import Heading from "../../../../components/typography/Heading";
import Text from "../../../../components/typography/Text";
import TextField from "../../../../components/input/textfield/TextField";
import Button from "../../../../components/buttons/Button";
import StatusAlert from "../../../../components/alerts/StatusAlert";
import FeedbackStatus from "../../../../components/feedback/FeedbackStatus";

import { useForgotPassword } from "../../hooks/useForgotPassword";

import "./ForgotPasswordPage.css";

export default function ForgotPasswordPage() {
  const navigate = useNavigate();

  const { email, setEmail, status, handleSubmit } = useForgotPassword();

  useEffect(() => {
    document.title = "Katch | Forgot Password";
  }, []);

  const onSubmit = (event) => {
    event.preventDefault();

    if (!status.loading) {
      handleSubmit();
    }
  };

  return (
    <PageWrapper className="forgot-password-wrapper">
      <main className="forgot-password-page">
        {status.success ? (
          <div className="forgot-password-page__content">
            <FeedbackStatus
              title="Check your email"
              description={
                <span>
                  If an account exists for{" "}
                  <strong>{email || "this email"}</strong>, you'll receive
                  password reset instructions shortly. Check your inbox or spam
                  folder.
                </span>
              }
              buttonText="Back to Sign in"
              onAction={() => navigate("/sign-in")}
            />
          </div>
        ) : (
          <div className="forgot-password-page__content">
            <div className="forgot-password-page__header">
              <Heading as="h1" size="lg">
                Forgot password?
              </Heading>

              <Text as="p" size="sm" tone="secondary">
                Enter your email address and we'll send you instructions to
                reset your password.
              </Text>
            </div>

            <form className="forgot-password-page__form" onSubmit={onSubmit}>
              {status.message && <StatusAlert status={status} />}

              <TextField
                name="email"
                type="email"
                label="Email address"
                value={email}
                onChange={(event) => setEmail(event.target.value)}
                placeholder="name@example.com"
                autoComplete="email"
                required
              />

              <Button
                type="submit"
                value={status.loading ? "Sending..." : "Reset password"}
                variant="primary"
                disabled={status.loading}
              />
            </form>

            <div className="forgot-password-page__footer">
              <Text as="p" size="sm" tone="secondary">
                Remember your password?{" "}
                <Link to="/sign-in" className="forgot-password-page__link">
                  Sign in
                </Link>
              </Text>
            </div>
          </div>
        )}
      </main>
    </PageWrapper>
  );
}
